export default {
  // Common
  common: {
    app_code: 'dmp',
    collectedEvents: '収集イベント',
    resetView: '表示リセット',
    app_name: 'ひがしかわ観光DX',
    env_prod: '',
    env_prod_mobile: '',
    env_test: '【テスト環境】',
    env_local: '【ローカル環境】',
    env_test_mobile: '[テスト]',
    env_local_mobile: '[ローカル]',
    loading: '処理中...',
    logout: 'ログアウト',
    admin: '管理者',
    users: 'ユーザー',
    userRegistrationRequests: 'ユーザー登録申請',
    dataProviders: 'データプロバイダー',
    masterData: 'マスタデータ',
    postalCodes: '郵便番号マスタ',
    systemLogs: 'システムログ',
    language: '言語設定',
    changeLanguage: '言語変更',
    copyright: 'Copyright (C) 東川町観光DXコンソーシアム',
    errorGeneral: 'エラーが発生しました。再度お試しください。',
    notSet: '未設定',
    contact: 'お問い合わせ',
    calendar: {
      weekdays: {
        sun: '日',
        mon: '月',
        tue: '火',
        wed: '水',
        thu: '木',
        fri: '金',
        sat: '土',
      },
    },
    error_dialog: {
      default_title: 'エラー',
      ok: 'OK'
    },
    info_dialog: {
      default_title: 'お知らせ',
      ok: 'OK'
    },
    warning_dialog: {
      default_title: '警告',
      ok: 'OK'
    },
    confirm_dialog: {
      default_title: '確認',
      ok: 'OK',
      cancel: 'キャンセル'
    },
  },

  // Header
  header: {
    welcomeMessage: 'こんにちは、',
    nameTitle: ' さん'
  },

  // Side Menu
  sideMenues: {
    home: 'ホーム',
    events: 'イベント',
    accommodationBookings: '宿泊',
    import: 'インポート',
    export: 'エクスポート',
    masterData: 'マスタデータ',
    dataManagement: 'データ管理',
    donatorInformation: '寄附者情報',
    statisticData: '統計情報',
    eventOrganizers: 'イベント主催者',
  },

  // Pagination
  pagination: {
    itemsPerPage: '1ページあたりの表示件数',
    itemsCount: '{count}',
    showing: '{total} 件中 {from} - {to} 件を表示',
    page: 'ページ',
    totalPages: '/ {total}',
    no_records: '該当のレコードはありません。',
    per_page: {
      '25': '25件表示',
      '50': '50件表示',
      '100': '100件表示'
    }
  },

  // HTTP status error messages
  httpStatusMessages: {
    httpStatusTitle403: 'アクセス権限がありません',
    httpStatusMsg403: 'このページを表示する権限がありません。\n必要な権限を持っていない、またはアクセスが制限されています。',
    httpStatusTitle404: 'ページが見つかりません',
    httpStatusMsg404: 'ページが存在しないかURLに誤りがあります。',
    httpStatusTitle500: 'サーバーエラー',
    httpStatusMsg500: 'サーバーエラーが発生しました。\n時間を置いて再度アクセスください。'
  },

  // Validation messages
  validation: {
    required: {
      currentPassword: '現在のパスワードを入力してください。',
      newPassword: '新しいパスワードを入力してください。',
      confirmPassword: '新しいパスワード（確認）を入力してください。'
    },
    minLength: '新しいパスワードは8文字以上で入力してください。',
    mismatch: '新しいパスワードと確認用パスワードが一致しません。',
    error: 'パスワード変更に失敗しました。',
    password: {
      minLength: 'パスワードは8文字以上で入力してください。',
      invalidCharacters: 'パスワードは半角英数で大文字・小文字・数字・記号（! . ‒ _）をすべて含む8文字以上で設定してください',
      sameAsCurrentPassword: '現在と同じパスワードは設定できません。'
    }
  },

  // Password change related
  password: {
    change: 'パスワード変更',
    current: '現在のパスワード',
    new: '新しいパスワード',
    confirm: '新しいパスワード（確認）',
    button: 'パスワード変更',
    cancel: 'キャンセル',
    minLength: '8文字以上で入力してください',
    success: 'パスワードが正常に変更されました。',
    failed: 'パスワード変更に失敗しました。'
  },

  // Email change
  email: {
    change: 'メールアドレス変更',
    current: '現在のメールアドレス',
    new: '新しいメールアドレス',
    button: 'メールアドレス変更',
    cancel: 'キャンセル',
    success: 'メールアドレス変更リクエストを送信しました。新しいメールアドレス宛に確認メールを送信しました。',
    failed: 'メールアドレス変更に失敗しました。',
    confirmSuccess: 'メールアドレスが正常に変更されました。',
    confirmFailed: 'メールアドレス変更の確認に失敗しました。',
    complete: {
      title: 'メールアドレス変更完了',
      message: 'メールアドレスの変更が完了しました。新しいメールアドレスでログインしてください。',
      loginButton: 'ログイン画面へ',
      processing: '処理中...',
      errorTitle: 'エラーが発生しました',
      invalidToken: 'トークンが無効です。',
      tokenNotFound: 'トークンが見つかりません。',
      tokenExpired: 'トークンの有効期限が切れています。',
      failed: 'メールアドレスの変更に失敗しました。'
    },
    validation: {
      currentEmailRequired: '現在のメールアドレスを入力してください。',
      currentEmailInvalid: '現在のメールアドレスの形式が正しくありません。',
      newEmailRequired: '新しいメールアドレスを入力してください。',
      newEmailInvalid: '新しいメールアドレスの形式が正しくありません。',
      sameEmail: '現在のメールアドレスと同じメールアドレスは使用できません。'
    }
  },

  // Legal pages
  legal: {
    titleTermsOfUse: '利用規約',
    titlePrivacyPolicy: 'プライバシーポリシー',
    titleExternalTools: '外部送信ツールに関わる公表事項',
  },

  // Authentication pages
  auth: {
    // Login page
    login: {
      title: 'ログイン',
      subtitle: 'ユーザー画面',
      subtitle_admin: 'システム管理画面',
      email: 'メールアドレス',
      password: 'パスワード',
      remember: 'ログイン状態を保持する',
      submit: 'ログイン',
      signupLink: '新規登録申請',
      forgotPasswordLink: 'パスワードをお忘れの方',
      forNewUserTitle: '初めてご利用の方',
      forNewUserDescription: 'ひがしかわ観光DXのご利用は登録申請が必要です。承認完了後にログインができるようになります。',
      validation: {
        emailRequired: 'メールアドレスを入力してください。',
        emailInvalid: '正しいメールアドレス形式で入力してください。',
        passwordRequired: 'パスワードを入力してください。'
      },
      error: {
        invalid_credentials: 'メールアドレスまたはパスワードが間違っています',
        failed: 'ログインに失敗しました。'
      }
    },

    // Admin Login page
    adminLogin: {
      title: 'DMP 管理 Web',
      email: 'メールアドレス',
      password: 'パスワード',
      remember: 'ログイン状態を保持する',
      submit: 'ログイン',
      authOidc: 'Microsoft Entra ID 認証',
      emailLoginNotice: 'メールアドレスでログイン',
      forgotPasswordLink: 'パスワードをお忘れの方',
      error: {
        failed: 'Microsoft Entra ID ログインに失敗しました。'
      }
    },

    activate_success: '本登録が完了しました',
    logout_success: 'ログアウトしました',

    // Signup page
    signup: {
      title: '新規登録申請',
      description: 'ひがしかわ観光DXのご利用は登録申請が必要です。承認完了後にログインができるようになります。',
      name: '名前',
      email: 'メールアドレス',
      officeName: '施設名',
      postalCode: '郵便番号',
      address: '住所',
      phoneNumber: '電話番号',
      organization: '所属団体',
      selectOrganization: '所属団体を選択してください',
      organizations: {
        noOrganization: '所属なし',
        tourAssociate: '東川町観光協会',
        chamberCommerce: '東川町商工会'
      },
      submit: '確認画面へ',
      confirmTitle: '申請内容確認',
      confirmDescription: '内容をご確認のうえ、「申請する」にお進みください。',
      register: '申請する',
      back: '修正する',
      loginLink: 'ログインはこちら',
      successTitle: '申請を受け付けました',
      successMessage: '承認完了後にお送りするメールから本登録にお進みください。',
      backToLogin: 'ログイン画面に戻る',
      validation: {
        nameRequired: 'ユーザー名を入力してください。',
        nameMaxLength: 'ユーザー名は255文字以内で入力してください。',
        emailRequired: 'メールアドレスを入力してください。',
        emailInvalid: '正しいメールアドレス形式で入力してください。',
        emailMaxLength: 'メールアドレスは255文字以内で入力してください。',
        officeNameRequired: '施設名を入力してください。',
        officeNameMaxLength: '施設名は255文字以内で入力してください。',
        postalCodeRequired: '郵便番号を入力してください。',
        postalCodeInvalid: '郵便番号は「999-9999」の形式で入力してください。',
        addressRequired: '住所を入力してください。',
        addressMaxLength: '住所は255文字以内で入力してください。',
        phoneNumberRequired: '電話番号を入力してください。',
        phoneNumberInvalid: '電話番号は「+」（半角記号）と半角数字のみ、最大15桁まで入力可能です。',
        organizationRequired: '所属団体を選択してください。'
      },
      agreePrefix: '',
      agreeConjunction: '、',
      agreeSuffix: 'に同意する'
    },

    // Activate page
    activate: {
      title: '会員本登録',
      description: 'パスワードは半角英数で大文字・小文字・数字・記号（! . ‒ _）をすべて含む8文字以上で設定してください',
      password: 'パスワード',
      passwordConfirm: 'パスワード（確認）',
      submit: '登録する',
      loading: 'ユーザー情報を読み込み中...',
      successTitle: '本登録完了',
      successMessage: '会員登録が完了しました',
      goHome: 'ホームに移動',
      errorTitle: 'エラーが発生しました',
      backToLogin: 'ログイン画面に戻る',
      invalidToken: '無効なリンクです。認証トークンが見つかりません。',
      tokenExpired: 'トークンが無効か、既に使用済みです。',
      userNotFound: 'ユーザー情報の取得に失敗しました。',
      activationFailed: '会員登録に失敗しました。',
      validation: {
        passwordRequired: 'パスワードを入力してください。',
        passwordMinLength: 'パスワードは8文字以上で入力してください。',
        passwordConfirmRequired: 'パスワード確認を入力してください。',
        passwordMismatch: 'パスワードが一致しません。'
      }
    },

    // Forgot password page
    forgotPassword: {
      title: 'パスワードをお忘れの方',
      description1: '登録したメールアドレスを入力してください。',
      description2: 'パスワード再設定用のメールを送信します。',
      email: 'メールアドレス',
      submit: '確認メールを送信',
      backToLogin: '戻る',
      success: 'パスワードを再設定するためのメールを送信しました。メールをご確認ください。',
      failed: 'メール送信に失敗しました。しばらく時間をおいて再度お試しください。',
      confirmTitle: '確認メールをご確認ください',
      confirmDescription1: '次のメールアドレスにメールを送信しました：',
      confirmDescription2: '記載されているURLからパスワードの再設定を行なってください。',
      validation: {
        emailRequired: 'メールアドレスを入力してください。',
        emailInvalid: 'メールアドレス形式が正しくありません。'
      }
    },

    // Reset password page
    resetPassword: {
      title: 'パスワードの再設定',
      description1: '新しいパスワードを入力してください。',
      description2: '※パスワードは半角英数で大文字・小文字・数字・記号（! . ‒ _）をすべて含む8文字以上で設定してください',
      email: 'メールアドレス',
      password: '新しいパスワード',
      passwordConfirm: '新しいパスワード（確認）',
      submit: 'パスワードを再設定する',
      backToLogin: 'ログイン画面に戻る',
      success: 'パスワードを再設定しました',
      failed: 'パスワードの再設定に失敗しました',
      validation: {
        emailRequired: 'メールアドレスを入力してください。',
        emailInvalid: 'メールアドレス形式が正しくありません。',
        passwordRequired: 'パスワードを入力してください。',
        passwordMinLength: 'パスワードは8文字以上で入力してください。',
        passwordConfirmRequired: 'パスワード（確認）を入力してください。',
        passwordMismatch: 'パスワードが一致しません。',
        sameAsCurrentPassword: '現在と同じパスワードは設定できません。'
      }
    }
  },

  // Data Providers (Laravel translation structure)
  // API Call Histories
  api_call_histories: {
    title: '公開APIの呼び出し状況',
    note: '※ 連携元システムごとの呼び出し件数とステータスコードを集計しています。リクエスト・レスポンスの本文は表示していません。',
    days: '直近{days}日',
    data_provider: '連携元',
    endpoint: 'エンドポイント',
    method: 'メソッド',
    status_code: 'ステータス',
    calls: '件数',
    first_called_at: '最初の呼び出し',
    last_called_at: '最後の呼び出し',
    empty: '対象期間に呼び出しの記録がありません。',
    failures_title: '失敗した呼び出しの内訳',
    failures_note: '※ 検証エラーになった項目名のみを表示しています。送信された値は表示していません。',
    message: 'メッセージ',
    rejected_fields: 'エラーになった項目',
    value_types_title: '拒否された値の型',
    value_types_note: '※ 直近の失敗5件について、検証で拒否された値の型のみを集計しています。値そのものは取得していません。',
    value_type: '型',
    occurrences: '出現数',
  },

  data_providers: {
    title: 'データプロバイダー',
    name: '名前',
    status: 'ステータス',
    description: '説明',
    register: '登録',
    edit: '編集',
    delete: '削除',
    details: '詳細',

    // Status
    status_values: {
      active: 'アクティブ',
      inactive: '非アクティブ'
    },

    // Form
    form: {
      title: 'データプロバイダーの登録',
      edit_title: 'データプロバイダーの編集',
      name_label: '名前',
      status_label: 'ステータス',
      status_placeholder: 'ステータスを選択してください',
      description_label: '説明',
      register_button: '登録',
      update_button: '更新',
      cancel: 'キャンセル',
      create_note: 'トークン管理は作成後に詳細画面で行えます。'
    },

    // Messages
    messages: {
      created: 'データプロバイダー「{name}」を登録しました。',
      updated: 'データプロバイダー「{name}」を更新しました。',
      deleted: 'データプロバイダー「{name}」を削除しました。',
      confirm_delete: '本当に削除してもよろしいですか？'
    }
  },

  // Token Management
  tokens: {
    title: 'トークン管理',
    generate_token: 'トークン生成',
    personal_access_tokens: 'パーソナルアクセストークン',
    name: '名前',
    token_value: 'トークン値',
    abilities: '権限',
    expires_at: '有効期限',
    created_at: '作成日時',
    actions: '操作',
    delete: '削除',
    copy_token: 'トークンをコピー',
    token_not_shown_after_creation: '（作成後、トークンは表示されません）',
    never_expires: '無期限',
    no_tokens: 'トークンが見つかりません。',

    // Messages
    messages: {
      token_generated: 'トークンが正常に生成されました。',
      token_deleted: 'トークンが正常に削除されました。',
      token_copied: 'トークンをクリップボードにコピーしました。',
      copy_failed: 'トークンのコピーに失敗しました。',
      confirm_delete_token: 'このトークンを削除してもよろしいですか？',
      enter_token_name: 'トークンの名前を入力してください：',
      max_tokens_reached: 'データプロバイダーごとに作成できるトークンは最大10個までです。'
    }
  },

  // Dashboard related
  dashboard: {
    title: 'ダッシュボード',
    subtitle: '日次で宿泊予約、イベント予約、訪問者トレンドなどをトラッキングしています',
    tooltip: '選択中期間の宿泊予約またはイベント予約をしている訪問者数を集計',

    // Time periods
    periods: {
      yesterday: '前日',
      today: '本日',
      tomorrow: '翌日'
    },

    // Statistics labels
    stats: {
      hotelBookings: '宿泊予約件数',
      eventBookings: 'イベント予約件数',
      eventsCount: 'イベント件数',
      hotelBookingsDesc: '予約件数であり、宿泊予定者数ではありません',
      eventBookingsDesc: '予約件数であり、イベント予約者数ではありません',
      eventsCountDesc: '昨日分は実績件数、本日または明日の分は予定件数'
    },

    // Chart
    chart: {
      title: '訪問者数推移',
      subtitle: '予定および実績',
      thisYearVisitors: '年',
      lastYearVisitors: '年',
      period: {
        oneWeek: '1週間',
        oneMonth: '1ヶ月',
        threeMonths: '3ヶ月'
      }
    },

    // Summary stats
    summary: {
      totalHotelBookings: '宿泊予約件数合計',
      totalEventBookings: 'イベント予約件数合計',
      totalEvents: 'イベント数合計',
      avgDailyVisitors: '日次平均訪問者数',
      periods: {
        threeDayTotal: '本日を含む直近3日間の予定件数',
        thirtyDayAverage: '過去30日間平均'
      }
    },

    // Home page
    home: {
      title: 'ホーム',
    },

    // Visitor Card
    visitor: {
      title: '訪問者数',
      person_unit: '名',
      year_label: '{year}年',
      selected_period_label: '選択期間',
      previous_year_same_period_label: '前年同期間',
    },

    // Daily Visitor Card
    daily_visitor: {
      residential_area: '居住エリア',
      visitor: '訪問者',
      others: 'その他',
      unanswered: '未回答',
      no_data: 'データなし',
    },

    // Date Range Picker
    date_range: {
      cancel: 'キャンセル',
      apply: '適用',
      alert: {
        max_range: '日付範囲は最大{days}日間まで選択できます。',
        select_dates: '開始日と終了日の両方を選択してください。',
      },
    },

    // Repeat Visitors & Higashikawa Shareholder
    stats: {
      title_repeat_visitors: '訪問リピーター',
      title_higashikawa_stockholder_visitors: 'ひがしかわ株主',
      number_unit: '%',
      trend_up: '↑',
      trend_down: '↓',
      trend_na: '± N/A (前年データなし)',
    },

    // Demographics
    demographics: {
      title_age_group: '年齢層',
      title_gender: '性別',
      age_group_less_20: '〜19',
      age_group_20: '20〜29',
      age_group_30: '30〜39',
      age_group_40: '40〜49',
      age_group_50: '50〜59',
      age_group_more_60: '60〜',
      age_group_unknown: 'その他',
      gender_male: '男性',
      gender_female: '女性',
      gender_unknown: 'その他',
    },

    // Occupancy Card
    occupancy: {
      title: '宿泊稼働率',
      subtitle: 'tomarin経由での予約数',
      detail_link: '宿泊予約詳細',
      occupancy_rate: '稼働率',
      total_rooms: '全客室数',
      booked_rooms: '予約客室数',
      rooms_unit: '室',
      additional_note: '※「全客室数×選択期間日数」に対する「期間中の日ごとのtomarin経由での宿泊予約済みの客室数の合計」の割合を表示しています。',
      booked_rooms_label: '予約済み',
      available_rooms_label: '空室',
    },

    // Crowd Level Calendar Card
    crowdLevelCalendar: {
      title: 'イベント実施状況',
      legend: {
        crowded: '100名〜',
        crowdedBit: '50〜99名',
        crowdedModerate: '1〜49名',
        crowdedNone: '0名',
      },
      modal: {
        title: 'イベント実施状況詳細',
        date: '日付',
        totalEvents: 'イベント件数',
        eventCapacities: '定員',
        eventParticipants: '参加者数',
        forecastedEventParticipants: '平均日次予測参加者数',
        unit: '件',
        peopleUnit: '名',
      },
    },

    // Events Combined Card
    events: {
      reservation_title: 'イベント予約数',
      reservation_subtitle: '開催イベントと予約数',
      event_reservation_label: 'イベント予約',
      user_attributes: 'ユーザー属性',
      shareholder: 'ひがしかわ株主',
      repeater: '来訪リピーター',
      repeater_only: 'リピーター',
      stockholder_only: '株主',
      both: 'リピーターかつ株主',
      other: 'その他',
      total: '合計',
      peopleUnit: '名',
      booked_label: '予約済み',
      available_label: '空き',
      total_capacity: 'イベント実施計：{count}名',
      top_events: '上位イベント',
      table: {
        event_name: 'イベント名',
        capacity: '定員',
        online: 'オンライン',
        organizer: '主催',
        date: '開催日',
      },
      event_list_link: '開催イベント一覧',
      no_data: 'データなし',
    },

    tooltips: {
      visitorCard: '選択中期間の宿泊予約またはイベント予約をしている訪問者数を集計',
      repeatVisitorCard: '選択期間における過去に訪問歴のある方の割合です。増減率は前年同期間との比較値を表しています。期間中の訪問者を個別にカウントしているため、合計人数は日次の訪問者推移のグラフの数値と一致しません。',
      higashikawaStockholderVisitorCard: '選択期間におけるひがしかわ株主の割合です。増減率は前年同期間との比較値を表しています。期間中の訪問者を個別にカウントしているため、合計人数は日次の訪問者推移のグラフの数値と一致しません。',
      ageGroupChartCard: '選択中期間の訪問者を年齢別に集計（未回答はのぞく）。集計方法が異なるため、合計人数は訪問者推移のグラフとは一致しません。',
      genderChartCard: '選択中期間の訪問者の性別を集計（未回答はのぞく）。集計方法が異なるため、合計人数は訪問者推移のグラフとは一致しません。',
      occupancyCard: '「全客室数×選択期間日数」に対する「期間中の日ごとのtomarin経由での宿泊予約済みの客室数の合計」の割合を表示しています。',
      crowdLevelCalendarCard: 'カレンダーで選択された期間の開始日が属する月のイベント参加者人数（予約人数および予測人数の合計）によって色分けをしています。なお、オンラインイベントはカレンダー上には表示していません。',
      topEvents: 'カレンダーで選択された期間で予定されているイベントのうち、定員数の多い上限5つのイベントを表示しています。',
    },

    // Repeat Visitor Detail Modal
    repeatVisitorDetail: {
      selectedPeriod: '選択期間',
      previousYearPeriod: '前年期間',
      changeRate: '前年比　',
      repeatVisitors: 'リピーター: ',
      total: '合計: ',
      personUnit: '名',
      additionalNote: '※期間中の訪問者を個別にカウントしているため、合計人数は日次の訪問者推移のグラフの数値と一致しません。',
    },

    // Higashikawa Stockholder Visitor Detail Modal
    higashikawaStockholderVisitorDetail: {
      selectedPeriod: '選択期間',
      previousYearPeriod: '前年期間',
      changeRate: '前年比　',
      higashikawaStockholderVisitors: '株主: ',
      total: '合計: ',
      personUnit: '名',
      additionalNote: '※期間中の訪問者を個別にカウントしているため、合計人数は日次の訪問者推移のグラフの数値と一致しません。',
    },

    // Age Group Visitor Detail Modal
    ageGroupVisitorDetail: {
      additionalNote: '※選択中期間の訪問者を年齢別に集計（未回答はのぞく）。集計方法が異なるため、合計人数は訪問者推移のグラフとは一致しません。',
      peopleUnit: '名',
    },

    // Gender Visitor Detail Modal
    genderVisitorDetail: {
      additionalNote: '※選択中期間の訪問者の性別を集計（未回答はのぞく）。集計方法が異なるため、合計人数は訪問者推移のグラフとは一致しません。',
      peopleUnit: '名',
    },
  },

  // Master Data
  guestDemographics: {
    age_less_20: '〜20',
    age_20: '20〜30',
    age_30: '30〜40',
    age_40: '40〜50',
    age_50: '50〜60',
    age_more_60: '60〜',
    age_other: 'その他',
    male: '男性',
    female: '女性',
    no_answer: '回答なし',
  },
  eventDetail: {
    edit: '編集',
    eventDate: '開催日',
    fee: '参加費用',
    capacity: '定員',
    peopleUnit: '名',
    currencyUnit: '円',
    dateFormat: '{year}年{month}月{day}日',
    bookingRate: '予約数',
    accommodationGuests: '町内宿泊者',
    repeaters: '来訪リピーター',
    stockholders: 'ひがしかわ株主',
    ageGroups: '年齢層',
    genders: '性別',
    genderNoAnswer: '回答なし',
    residentialAreas: '居住エリア',
    distributionComparison: '分布比較',
    participants: '参加者',
    allEvents: '全イベント',
    showMore: 'もっと見る',
    showLess: '閉じる',
    noData: 'データがありません',
    loading: '読み込み中...',
    notFound: 'イベントが見つかりませんでした',
  },
  accommodationSummary: {
    title: '宿泊',
    bookings: '予約数',
    bookingsSubtitle: 'tomarin経由の予約推移',
    help: '選択した期間の宿泊予約データを表示します。数値は毎朝の集計時点のものです。',
    resetView: '表示リセット',
    peopleUnit: '名',
    selectedPeriod: '選択期間',
    previousYearPeriod: '前年同期間',
    occupancy: '客室稼働',
    repeaters: '宿泊リピーター',
    stockholders: 'ひがしかわ株主',
    ageGroups: '年齢層',
    genders: '性別',
    genderNoAnswer: '回答なし',
    residentialAreas: '居住エリア',
    noData: 'データがありません',
  },
  collectedEvents: {
    tabSources: '収集元',
    sourceUrl: 'URL',
    sourceMethod: '取得方式',
    sourceTotal: '収集累計',
    sourceLastRun: '最終収集',
    sourceNeverRun: '未実行',
    sourceOk: '成功',
    sourceFailed: '失敗',
    category: 'カテゴリ',
    collectNow: '今すぐ収集',
    collectErrors: '失敗した収集元',
    collectFailed: '収集に失敗しました。',
    title: '収集イベント',
    description: '町内サイトから毎朝自動収集したイベント候補です。内容を確認して登録するか、対象外にしてください。登録したイベントは下書き状態で作成されます。',
    source: '収集元',
    eventTitle: 'イベント名',
    period: '開催日',
    venue: '会場',
    actions: '操作',
    approve: '登録',
    reject: '対象外',
    approveTitle: 'イベントとして登録',
    approveNote: '収集した内容は自動抽出のため誤りがある場合があります。登録前に内容を確認・修正してください。',
    approveSubmit: '登録する',
    approveFailed: '登録に失敗しました。',
    cancel: 'キャンセル',
    startDate: '開始日',
    endDate: '終了日',
    capacity: '定員',
    feeAmount: '参加費(円)',
    feeSource: '収集した記載',
    descriptionLabel: '説明',
    statusPending: '未確認',
    statusApproved: '登録済み',
    statusRejected: '対象外',
    loading: '読み込み中...',
    empty: '該当するイベントはありません',
  },
  adminDashboard: {
    pendingRequests: '承認待ちのユーザー登録申請',
    errors24h: '直近24時間のエラー',
    countUnit: '件',
    errorsBreakdown: '公開API: {api} / 画面操作: {operation}',
    providersTitle: 'データプロバイダー受信状況',
    providerName: 'プロバイダー名',
    lastCalledAt: '最終受信',
    calls24h: '24時間の呼び出し',
    providerErrors24h: '24時間のエラー',
    neverCalled: '受信なし',
    noProviders: 'データプロバイダーがありません',
    tablesTitle: '主要データ件数',
    loading: '読み込み中...',
  },
  masterData: {
    title: 'マスタデータ一覧',
    detailTitle: 'マスタデータ詳細',
    tableNameHeader: 'テーブル名称',
    rowCountHeader: '行数',
    lastUpdatedHeader: '最終更新',
    loading: '読み込み中...',
    noTablesFound: 'テーブルが見つかりませんでした',
    filters: {
      createdDate: '作成日',
      updatedDate: '更新日',
      searchButton: '検索',
      filterStart: '絞り込み始点',
      filterEnd: '絞り込み終点',
      toggleIncludeDeleted: '削除済みを含む'
    },
  },

  // Accommodation Bookings
  accommodationBookings: {
    title: '宿泊予約一覧',
    loading: '読み込み中...',
    noBookingsFound: '宿泊予約が見つかりませんでした',
    filters: {
      checkinDate: 'チェックイン',
      checkoutDate: 'チェックアウト',
      status: 'ステータス',
      allStatus: '全てのステータス',
      searchButton: '検索',
      filterStart: '開始日',
      filterEnd: '終了日'
    },
    status: {
      confirmed: '確定',
      cancelled: 'キャンセル',
      pending: '保留中'
    },
    table: {
      id: 'ID',
      hotelName: '宿泊施設名',
      checkinDate: 'チェックイン',
      checkoutDate: 'チェックアウト',
      guestCount: '宿泊者数',
      hasMeal: '食事あり',
      hasEventGuests: 'イベント予約有無',
      totalPrice: '合計金額',
      status: 'ステータス',
      createdAt: '作成日時'
    },
    csvExport: {
      button: 'CSV出力',
      title: 'CSV出力',
      message: '検索結果 {count} 件をCSV出力します。',
      encodingLabel: 'エンコーディング',
      cancel: 'キャンセル',
      export: '出力',
      exporting: '出力中...'
    }
  },

  // Postal Codes
  postalCodes: {
    title: '郵便番号マスタ',
    csvImport: 'CSVインポート',
    importing: 'インポート中...',
    importComplete: 'インポート完了',
    importCount: 'インポート件数: {count} 件',
    errors: 'エラー:',
    moreErrors: '...他 {count} 件',
    table: {
      postalCode: '郵便番号',
      prefecture: '都道府県',
      city: '市区町村',
      area: '町域',
      prefectureKana: '都道府県（カナ）',
      cityKana: '市区町村（カナ）',
      areaKana: '町域（カナ）'
    },
    importModal: {
      title: 'CSVファイルインポート',
      fileLabel: 'CSVファイルを選択してください',
      fileHelp: '日本郵政のken_all.csvファイル（Shift-JISエンコード）をアップロードしてください。',
      cancel: 'キャンセル',
      import: 'インポート'
    }
  },

  // Import
  import: {
    ledghome: {
      title: 'インポート > 寄附者情報',
      description: 'LedgHome からエクスポートした「寄附者情報」のCSVファイルをインポートします。',
      dropMessage: 'こちらをクリックしてファイルを選択するか\nファイルをドラッグしてください',
      importButton: 'インポートする',
      importing: 'インポート中...',
      maxFilesError: 'ファイルは最大{max}件までアップロードできます',
      importError: 'インポートに失敗しました',
      results: {
        title: 'インポート結果',
        titleSuccess: 'インポート完了',
        titleWithErrors: 'インポートエラー',
        totalFiles: '処理ファイル数',
        processedFiles: '正常処理ファイル数',
        totalRows: '処理行数',
        createdDonators: '新規寄附者数',
        updatedDonators: '更新寄附者数',
        createdStockholders: '新規株主数',
        updatedStockholders: '更新株主数',
        deletedStockholders: '削除株主数',
        errors: 'エラー'
      }
    },
    messages: {
      data_provider_not_found: 'データプロバイダーが見つかりません',
      import_completed: 'インポートが完了しました',
      import_failed: 'インポートに失敗しました',
      donator_number_required: '寄附者Noが必要です'
    },
    validation: {
      files_required: 'ファイルを選択してください',
      files_array: 'ファイルは配列である必要があります',
      files_max: 'ファイルは最大10件までアップロードできます',
      file_required: 'ファイルが必要です',
      file_type: 'ファイルタイプが不正です',
      file_mimes: 'CSVファイル（.csv、.txt）のみアップロード可能です',
      file_size_max: 'ファイルサイズは最大50MBまでです'
    }
  },

  // Events
  events: {
    titleList: '開催イベント一覧',
    helpTooltip: 'カレンダーで選択された期間で予定されているイベントを表示しています',
    eventName: 'イベント名',
    capacity: '定員',
    isOnline: 'オンライン',
    organizer: '主催',
    eventDate: '開催日',
    fee: '参加費',
    noData: 'データがありません',
    loading: '読み込み中...',
    additionalOrganizers: '他{count}事業者',
  },

  // Event Organizers
  eventOrganizers: {
    title: 'イベント主催者',
    titleList: 'マスタデータ',
    edit: '編集',
    create: '登録',
    search: '検索',
    searchPlaceholder: '主催者名で検索...',
    addNew: '新規追加',
    organizer: '主催者',
    organizerName: '主催者名称',
    phoneMain: '電話番号(メイン)',
    phoneSub: '電話番号(サブ)',
    emailMain: 'メールアドレス(メイン)',
    emailSub: 'メールアドレス(サブ)',
    address: '住所',
    postalCode: '郵便番号',
    postalCodePlaceholder: '888-8888',
    prefecture: '都道府県',
    prefectureDefault: '選択してください',
    city: '市区町村',
    cityPlaceholder: '上川郡東川町',
    cityDetail: '市区町村以降',
    cityDetailPlaceholder: '1-1-1',
    building: '建物名',
    buildingPlaceholder: 'せんとぴゅあ',
    delete: '削除する',
    cancel: 'キャンセル',
    update: '更新する',
    noData: 'データがありません',
    loading: '読み込み中...',
    required: '必須',
    confirmDelete: '本当に削除しますか？この操作は取り消せません。',
    errorFetchData: 'データの取得に失敗しました',
    successUpdate: '主催者情報を更新しました',
    successCreate: '主催者情報を作成しました',
    errorSave: '保存に失敗しました',
    successDelete: '主催者情報を削除しました',
    errorDelete: '削除に失敗しました',
    errorDeleteInUse: 'このイベント主催者は既にイベントで使用されているため削除できません。先にイベントデータから主催者を削除してください。',
    validation: {
      nameRequired: '主催者名称を入力してください',
      nameMaxLength: '主催者名称は255文字以内で入力してください',
      phoneInvalid: '電話番号は数字とハイフン(-)で入力してください',
      phoneMaxLength: '電話番号は20文字以内で入力してください',
      emailInvalid: '正しいメールアドレスの形式で入力してください',
      emailMaxLength: 'メールアドレスは255文字以内で入力してください',
      postalCodeRequired: '郵便番号を入力してください',
      postalCodeInvalid: '郵便番号は999-9999の形式で入力してください',
      postalCodeMaxLength: '郵便番号は10文字以内で入力してください',
      prefectureRequired: '都道府県を選択してください',
      cityRequired: '市区町村を入力してください',
      cityMaxLength: '市区町村は100文字以内で入力してください',
      townMaxLength: '市区町村以降は100文字以内で入力してください',
      buildingMaxLength: '建物名は200文字以内で入力してください'
    },
    messages: {
      fetchFailed: 'データの取得に失敗しました',
      updated: '主催者情報を更新しました',
      created: '主催者情報を作成しました',
      saveFailed: '保存に失敗しました',
      deleted: '主催者情報を削除しました',
      deleteFailed: '削除に失敗しました'
    }
  },

  // Master Events
  masterEvents: {
    title: 'イベント',
    titleList: 'マスタデータ',
    searchPlaceholder: 'イベント名で検索...',
    addNew: '新規追加',
    eventName: 'イベント名',
    description: '説明',
    startDate: '開始日',
    endDate: '終了日',
    capacity: '定員',
    forecastedVisitorCount: '平均日次予測訪問者数',
    isOnline: 'オンライン',
    organizer: '主催者',
    feeMax: '費用（上限）',
    feeMin: '費用（下限）',
    noData: 'データがありません',
    loading: '読み込み中...',
    // Form
    edit: '編集',
    create: '登録',
    createButton: '登録する',
    update: '更新する',
    cancel: 'キャンセル',
    delete: '削除する',
    confirmDelete: '本当に削除しますか？この操作は取り消せません。',
    // Organizers section
    organizers: 'イベント主催者',
    selectOrganizer: '主催者を選択',
    isPrimary: '代表主催者',
    addOrganizer: '主催者を追加',
    // Fees section
    fees: '参加費用',
    feeType: '種別',
    feeAmount: '金額',
    feeDescription: '説明',
    addFee: '参加費を追加',
    // Messages
    errorFetchData: 'データの取得に失敗しました',
    successCreate: 'イベントを作成しました',
    successUpdate: 'イベントを更新しました',
    successDelete: 'イベントを削除しました',
    errorSave: '保存に失敗しました',
    errorDelete: '削除に失敗しました',
    errorDeleteInUse: 'このイベントには予約データが紐づいているため削除できません。',
    // Validation
    // Image upload section
    addImage: '画像を追加',
    imageCountHint: '最大5枚まで',
    analyzing: 'AI解析中...',
    analyzeWithAI: 'AIで解析',
    // Event form
    eventNumber: 'イベント{n}',
    organizerTooltip: 'イベント主催者マスタに登録されている主催者を選択してください',
    searchOrganizer: '主催者を検索...',
    dateRange: '開催期間',
    currencyYen: '¥{amount}',
    capacityWithHint: '定員（なしの場合は空白）',
    capacityUnit: '名',
    forecastedVisitorCount: '平均日次予測訪問者数',
    onlineEvent: 'オンラインイベント',
    deleteEvent: 'イベント削除',
    addEventInput: 'イベント入力を追加',
    participationFee: '参加費',
    // Messages
    analyzeSuccess: 'イベントチラシの解析が完了しました',
    successCreateBulk: '{count}件のイベントを作成しました',
    errorNoFilesToAnalyze: '解析する画像がありません',
    errorAnalyze: 'イベントチラシの解析に失敗しました',
    validation: {
      titleRequired: 'イベント名を入力してください',
      titleMaxLength: 'イベント名は255文字以内で入力してください',
      startDateRequired: '開始日を入力してください',
      endDateRequired: '終了日を入力してください',
      endDateAfterStart: '終了日は開始日以降の日付を指定してください',
      organizerRequired: '少なくとも1つの主催者を追加してください',
      organizerSelectRequired: '主催者を選択してください',
      feeTypeRequired: '種別を入力してください',
      feeAmountRequired: '金額を入力してください',
      organizerDuplicate: '同じ主催者が複数選択されています',
      feeTypeDuplicate: '同じ種別名が複数設定されています',
      forecastedVisitorCountRequired: '定員が入力されていない場合、予測訪問者数の入力は必須です'
    }
  },

  // Export
  export: {
    statisticData: {
      title: 'エクスポート > 統計情報',
      description: '本サービスで生成された各種統計情報を出力できます',
      periodLabel: '集計期間',
      dataTypeLabel: 'データ種別',
      dataTypes: {
        statistic_summaries: '総合統計',
        statistic_visitor_attributes: '訪問者属性',
        statistic_visitor_accommodation_bookings: '宿泊統計',
        statistic_visitor_event_bookings: 'イベント統計'
      },
      encodingLabel: '出力データ形式',
      encodings: {
        sjis: 'Shift-JIS',
        utf8: 'UTF-8'
      },
      exportButton: '出力',
      exporting: '出力中...',
      errors: {
        select_data_type: 'データ種別を選択してください',
        select_encoding: '出力データ形式を選択してください',
        max_days: '期間指定は100日以内にしてください',
        invalid_date_range: '終了日は開始日より後の日付を指定してください',
        no_permission: 'CSV操作権限がありません',
        export_failed: 'CSV出力に失敗しました',
        invalid_data: '入力データが正しくありません'
      },
      warnings: {
        not_implemented: '現在実装中のため出力できません',
      },
      tooltips: {
        dateRange: '日別に作成された統計情報の基準日の絞り込みに利用します。生成された統計情報データの期間内において、最大で100日間まで選択可能です。',
        encodingType: '原則として Windows の方は Shift-JIS、MacOS の方は UTF-8 をご利用ください。文字化けする場合はご利用環境で利用されているアプリケーションのエンコードの設定値をご確認ください。',
      }
    }
  }
};
